import { styled } from 'styled-components';

import { SEARCH_RESULTS_FIXED_HEADER_HEIGHT } from '#/modules/search/components/Results/Header/searchResultsHeaderConstants';
import { navigationTransitionCss } from '#/theme/navigationTransitionCss';
import { cssBreakpoints } from '#/theme/theme';

export const LayoutHolder = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(
    100dvh - var(--root-padding-top) - var(--root-padding-bottom)
  );

  @media print {
    min-height: unset;
  }
`;

export const LayoutChildrenHolder = styled.div`
  flex: 1;
  position: relative;

  ${navigationTransitionCss};
`;

export const LayoutBaseVariantProgressBarHolder = styled.div`
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
`;

export const LayoutMobileSearchPageFooterPadding = styled.div`
  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    height: ${SEARCH_RESULTS_FIXED_HEADER_HEIGHT};
  }
`;
